var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99956 4.03965L8.71206 0.327148L9.77256 1.38765L6.06006 5.10015L9.77256 8.81265L8.71206 9.87315L4.99956 6.16065L1.28706 9.87315L0.226562 8.81265L3.93906 5.10015L0.226562 1.38765L1.28706 0.327148L4.99956 4.03965Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesRed);
export default __webpack_public_path__ + "static/media/Times-Red.5fe7fb301ddb4515e5bda485de6450e7.svg";
export { ForwardRef as ReactComponent };